export const BASE_URL = process.env.REACT_APP_BASE_URL;
// export const BASE_URL = ""; // If using proxy
export const URL = "/api/v1";
